var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select',{staticClass:"business-list__dropdown business-list__dropdown-tags",attrs:{"id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"required":_vm.required},on:{"change":_vm.getTags}})])}
var staticRenderFns = []

export { render, staticRenderFns }